// import React from "react";

// export default function Terms() {
//   return (
//     <div className="max-w-3xl mx-auto p-5 md:p-10">

//       {/* Page Title */}
//       <h1 className="text-3xl md:text-4xl font-bold text-center mb-8 text-[#011B8A]">
//         नियम व अटी
//       </h1>

//       {/* Card Box */}
//       <div className="bg-white shadow-xl rounded-xl p-6 md:p-8 border border-gray-200">

//         <ul className="list-disc list-inside space-y-4 text-lg leading-relaxed">

//           <li>
//             आपण खरेदी केलेली ब्लॅंकेट व त्या सोबत मिळणारी भेट वस्तू यांच्या आधारे 
//             आपल्याला कंपनीची रिसीट मिळेल.
//           </li>

//           <li>
//             कंपनी कडून खरेदी केलेल्या सर्व वस्तूंची सांगितलेल्या प्रमाणे 
//             ७ ते १० दिवसात आपणास डिलिव्हरी होईल.
//           </li>

//           <li>
//             लकी ड्रॉ च्या वस्तू दिलेल्या तारखेनुसार वितरित होतील.
//           </li>

//           <li>ही स्कीम केवळ भारतीय रहिवाशांसाठी खुली आहे.</li>

//           <li>
//             एका व्यक्तीला / मोबाईल नंबरला / पत्ताला केवळ एकच बक्षीस मिळू शकते.
//           </li>

//           <li>
//             बक्षीस हे स्वतःच्या स्वरूपामध्ये असेल आणि त्याऐवजी रोख रकम 
//             किंवा इतर वस्तू मागता येणार नाहीत.
//           </li>

//           <li>
//             आपल्या बक्षीस बदलण्याचा, रद्द करण्याचा किंवा 
//             त्याऐवजी दुसरे बक्षीस देण्याचा अधिकार फक्त आयोजकांचा आहे.
//           </li>

//           <li>
//             आपल्या बक्षीस मिळवण्यासाठी आपणास KYC कागदपत्रे व फॉर्म 
//             भरणे आवश्यक आहे.
//           </li>

//           <li>
//             विजेत्यांची निवड यादृच्छिक लकी ड्रॉ पद्धतीने केली जाईल.
//           </li>

//           <li>
//             बक्षीस दाव्यासाठी विशिष्ट कालमर्यादा (उदा. १० दिवस) असते.  
//             त्या मुदतीत दावा न केल्यास बक्षीस रद्द होते.
//           </li>

//           <li>
//             विजेत्याला बक्षीस घेण्यासाठी लागणारा खर्च (उदा. प्रवास खर्च) स्वतः करावा लागेल.
//           </li>

//           <li>
//             आयोजकांकडे कोणत्याही व्यक्तीला योजनेंतर्गत भाग देण्यास मनाई करण्याचा 
//             किंवा योजना कधीही रद्द करण्याचा अधिकार आहे.
//           </li>

//         </ul>

//         <p className="mt-8 text-blue-700 text-lg text-center">
//           अधिक माहितीसाठी <br />
//           <a
//             href="https://www.meruram.in"
//             target="_blank"
//             rel="noreferrer"
//             className="underline font-semibold"
//           >
//             www.meruram.in
//           </a>{" "}
//           ला भेट द्या.
//         </p>
//       </div>
//     </div>
//   );
// }



// import React from "react";

// export default function Terms() {
//   return (
//     <div className="max-w-3xl mx-auto p-5 md:p-10">

//       {/* Page Title */}
//       <h1 className="text-3xl md:text-4xl font-bold text-center mb-8 text-[#011B8A]">
//         Terms & Conditions
//       </h1>

//       {/* Card Box */}
//       <div className="bg-white shadow-xl rounded-xl p-6 md:p-8 border border-gray-200">

//         <ul className="list-disc list-inside space-y-4 text-lg leading-relaxed">

//           <li>
//             You will receive a company receipt based on the blanket you purchased
//             and the gift item received with it.
//           </li>

//           <li>
//             All purchased items will be delivered within 7 to 10 days as informed
//             by the company.
//           </li>

//           <li>
//             Lucky draw prizes will be distributed on the dates mentioned.
//           </li>

//           <li>This scheme is open only for Indian residents.</li>

//           <li>
//             Only one prize is allowed per person / mobile number / address.
//           </li>

//           <li>
//             The prize will be given only in its actual form and cannot be exchanged
//             for cash or any other item.
//           </li>

//           <li>
//             The organizers reserve the right to modify, cancel, or replace the prize
//             if needed.
//           </li>

//           <li>
//             To claim your prize, you must submit required KYC documents and fill
//             the claim form.
//           </li>

//           <li>
//             Winners will be selected through a random lucky draw process.
//           </li>

//           <li>
//             There is a specific time limit (e.g., 10 days) to claim the prize.
//             Failure to claim within this period will result in cancellation.
//           </li>

//           <li>
//             Any expenses related to collecting the prize (e.g., travel costs)
//             must be borne by the winner.
//           </li>

//           <li>
//             Organizers have the right to deny participation or cancel the scheme
//             at any time.
//           </li>

//         </ul>

//         <p className="mt-8 text-blue-700 text-lg text-center">
//           For more information, visit <br />
//           <a
//             href="https://www.meruram.in"
//             target="_blank"
//             rel="noreferrer"
//             className="underline font-semibold"
//           >
//             www.meruram.in
//           </a>
//         </p>
//       </div>
//     </div>
//   );
// }



import React from "react";
import { useTranslation } from "react-i18next";

export default function Terms() {
  const { t } = useTranslation();

  return (
    <div className="max-w-3xl mx-auto p-5 md:p-10">

      {/* Page Title */}
      <h1 className="text-3xl md:text-4xl font-bold text-center mb-8 text-[#011B8A]">
        {t("terms_title")}
      </h1>

      {/* Card Box */}
      <div className="bg-white shadow-xl rounded-xl p-6 md:p-8 border border-gray-200">

        <ul className="list-disc list-inside space-y-4 text-lg leading-relaxed">
          {t("terms_list", { returnObjects: true }).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <p className="mt-8 text-blue-700 text-lg text-center">
          {t("more_info")} <br />
          <a
            href="https://www.meruram.in"
            target="_blank"
            rel="noreferrer"
            className="underline font-semibold"
          >
            www.meruram.in
          </a>
        </p>
      </div>
    </div>
  );
}
